<template>
	<div>
		<h1>Oh dear, network issues!!!</h1>
		<router-link :to="{ name: 'event-list' }">< Back to Home</router-link>
	</div>
</template>

<script>
export default {
	props: {
		resource: {
			type: String,
			default: 'page'
		}
	}
}
</script>

